module.exports = __webpack_public_path__ + "media/images/feather-icon-606bba4c.png";